module.exports = __webpack_public_path__ + "assets/images/award-modal-bg.242248db.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/awards/award-modal-bg.jpeg
// module id = 195
// module chunks = 1612